<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 70vw">
      <div class="modal-header">
        <h5 class="modal-title">Record Consumables Used</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="loading" class="modal-body">
        <loader />
      </div>

      <div v-if="!loading" class="modal-body">
        <form @submit.prevent="submitConsumables">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <!-- This loop dynamically creates a row for each item in the consumables array -->
              <tr v-for="(item, index) in consumables" :key="index">
                <td>
                  <!-- The input fields are bound to the item's properties using v-model -->
                  <!-- <input
                    type="text"
                    v-model="item.name"
                    class="form-control"
                    placeholder="Item name" 
                  /> -->
                  <Iteminput
                    @itemoption-check="option_check"
                    :Rowid="index"
                    type="items"
                    :preselectedItemID="item.item_id"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    v-model="item.quantity"
                    class="form-control"
                  />
                </td>
                <td>
                  <!-- This button removes the corresponding item from the array -->
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="removeConsumable(index)"
                  >
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- This button adds a new, empty item to the array -->
          <button
            type="button"
            class="btn btn-primary btn-sm mt-3"
            @click="addConsumable"
          >
            Add Item
          </button>

          <div class="form-group row mt-4">
            <div class="col-sm-12">
              <button
                type="submit"
                class="btn btn-success"
                style="float: right"
              >
                Save Consumables
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Iteminput from "../../Inventory/components/iteminput.vue";
import { generalApiRequest } from "../../../api/apiIndex";
import { JsItemName } from "../../Inventory/components/jscomponents";
import loader from "../../special_clinics/dialysis/loader.vue";
// import { JsItemName } from "../../Inventory/components/jscomponents";
export default {
  name: "ConsumablesModal",
  data() {
    return {
      loading: false,
      // Initialize with one empty item
      consumables: [],
    };
  },
  props: {
    conducted_record: {
      type: Object,
    },
    is_dialysis: {
      type: [Number, String, Boolean],
      default: null,
    },
  },
  components: {
    Iteminput,
    loader,
  },
  computed: {
    isDialysis() {
      return this.is_dialysis == 1;
    },
  },
  methods: {
    option_check(option, row) {
      const newConsumables = [...this.consumables];
      newConsumables[row].item_id = option.id;
      newConsumables[row].name = JsItemName(
        option.brand_name,
        option.item_strength,
        option.item_name,
      );
      this.consumables = newConsumables;

      // console.log(
      //   "666666666666666executing the option check 6666666666666666666666666666"
      // );
      // console.log(option);
      // console.log(row);
      // console.log("6666666666666666666666666666666666666666666");
    },
    // Emits an event to the parent component to hide the modal
    closeModal() {
      this.$emit("hide-consumables-model");
    },
    // Adds a new row with default values
    addConsumable() {
      this.consumables.push({ name: "", quantity: 1 });
    },
    // Removes a specific row by its index
    removeConsumable(index) {
      this.consumables.splice(index, 1);
    },
    // Handles form submission and emits the data to the parent
    async submitConsumables() {
      this.loading = true;
      // console.log("Submitting consumables:", this.consumables);
      const url = "consumables/record_consumed";
      const body = {
        consumables: this.consumables,
        conducted_record: this.conducted_record,
        is_dialysis: this.isDialysis,
        department_id: this.isDialysis ? 7 : 2,
      };
      await generalApiRequest(url, "POST", body, 1);
      //   console.log(data);
      this.closeModal();
      this.loading = false;
    },
    async fetch_consumables() {
      if (!this.isDialysis) {
        try {
          this.loading = true;
          const url =
            "consumables/by_service" + this.conducted_record.charge_id;
          const body = {};
          const data = await generalApiRequest(url, "GET", body, 1);
          // console.log("=============================");
          // console.log("consumables/by_service/" + this.conducted_record.charge_id);

          // console.log(data);
          // console.log("=============================");

          //   this.consumables = data.consumables;
          var attained_set = [];
          data.consumables.forEach((element) => {
            var name = JsItemName(
              element.brand_name,
              element.item_strength,
              element.item_name,
            );
            var qty = element.quantity;
            var item_id = element.item_id;
            var obj = { name: name, quantity: qty, item_id: item_id };
            attained_set.push(obj);
          });

          if (attained_set.length > 0) {
            this.consumables = attained_set;
          } else {
            this.consumables = [{ name: "", quantity: 0, item_id: null }];
          }
          this.loading = false;
        } catch (error) {
          this.loading = false;
          console.log(error);
        }
      }
    },
  },
  mounted() {
    console.log(this.conducted_record);
    // this.fetch_consumables();
    if (typeof this.conducted_record == "number") {
      this.closeModal();
    } else {
      this.fetch_consumables();
    }
  },
};
</script>

<style scoped>
/* Scoped styles can be similar to your existing ones, or you can add new ones */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.mmodal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
